import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type PreviewOffCanvasState = {
    url: string;
    isOpen: boolean;
}

export const initialState: PreviewOffCanvasState = {
    url: '',
    isOpen: false,
}

export const slice = createSlice({
    name: 'previewOffCanvas',
    initialState,
    reducers: {
        openPreview: (state, action: PayloadAction<string>) => {
            state.url = action.payload;
            state.isOpen = true;
        },
        closePreview: (state) => {
            state.isOpen = false;
        }
    }
});

export const {openPreview, closePreview} = slice.actions;
export default slice.reducer;